require('./axios')
require('./vuetify')
require('./vuepaper')
require('./vuevideo')
require('./vuepdf')
require('./fb-sdk')
require('./g-auth')